import styles from './historyMobile.module.css';
import { Tooltip } from "@mui/material";
import { Check } from "react-feather";
import { useState } from "react";
import { useEffect } from "react";
import dayjs from "dayjs";

const HistoryMobile = ({ isPanelOpen, onToggle, histories, requestData }) => {
  const [historyList, setHistoryList] = useState([]);

  useEffect(() => {
    if (histories) {
      setHistoryList(histories);
    }
  }, [histories]);

  return (<>
    <div className={`${styles.AccordionList}`}>
      <div className={`${styles.AccordionListHead} ${isPanelOpen ? styles.Open : ""}`} onClick={() => onToggle("five")}>
        <p className={`${styles.Title}`}>History</p>
        <img src="/static/img/downTriangle.svg" alt='' />
      </div>
      {historyList.length > 0 && <div className={`${styles.AccordionListBody} ${isPanelOpen ? styles.Open : ""}`}>
        <div className={`${styles.cardUnderSBody}`}>
          <ul>
            {historyList?.map(item => {
              return <li className={`${styles.Completed}`}>
                <Tooltip title="Completed">
                  <span><Check /></span>
                </Tooltip>
                <div>
                  <p>{item.title}</p>
                  <p className={`${styles.Date}`}>{dayjs(item.created_at).format("L LT")}</p>
                  {item?.type === 'create' && <p className={`${styles.Description}`}><strong>{requestData?.tenant_name}</strong> created this request.</p>}
                  {item?.type === 'cancelled' && <p className={`${styles.Description}`}><strong>{item?.user_name}</strong> hold this request.</p>}
                  {item?.type === 'assign' && <p className={`${styles.Description}`}><strong>{item?.user_name}</strong> assigned this request to <strong>{item?.details !== '' ? item?.details : 'Technican'}</strong>.</p>}
                  {item?.type === 'schedule' && item?.details !== '' && <p className={`${styles.Description}`}><strong>{item?.user_name}</strong> scheduled this request on <strong>{item?.details}</strong>.</p>}
                  {item?.type === 'schedule' && item?.details === '' && <p className={`${styles.Description}`}><strong>{item?.user_name}</strong> scheduled this request.</p>}
                  {item?.type === 'reschedule' && item?.details !== '' && <p className={`${styles.Description}`}><strong>{item?.user_name}</strong> rescheduled this request on <strong>{item?.details}</strong>.</p>}
                  {item?.type === 'reschedule' && item?.details === '' && <p className={`${styles.Description}`}><strong>{item?.user_name}</strong> rescheduled this request.</p>}
                  {item?.type === 'pending_followup' && <p className={`${styles.Description}`}><strong>{item?.user_name}</strong> completed this request.</p>}
                  {item?.type === 'resolved' && <p className={`${styles.Description}`}><strong>{item?.user_name}</strong> resolved this request.</p>}
                  {item?.type === 'change_status' && <p className={`${styles.Description}`}>{item?.user_name}, {requestData?.property_name} changed request status from  {((parseInt(item?.prev_status) === 4) ? <span className={`${styles.Stat} ${styles.Cancelled}`}>Hold</span> : ((parseInt(item?.prev_status) === 3) ? <span className={`${styles.Stat} ${styles.Resolved}`}>Resolved</span> : ((parseInt(item?.prev_status) === 2) ? <span className={`${styles.Stat} ${styles.InProgress}`}>Scheduled</span> : ((parseInt(item?.prev_status) === 1) ? <span className={`${styles.Stat} ${styles.InProgress}`}>Assigned</span> : <span className={`${styles.Stat} ${styles.Open}`}>Open</span>))))} to {((parseInt(item?.current_status) === 3) ? <span className={`${styles.Stat} ${styles.Cancelled}`}>Hold</span> : ((parseInt(item?.current_status) === 2) ? <span className={`${styles.Stat} ${styles.Resolved}`}>Resolved</span> : ((parseInt(item?.current_status) === 2) ? <span className={`${styles.Stat} ${styles.InProgress}`}>Scheduled</span> : ((parseInt(item?.current_status) === 1) ? <span className={`${styles.Stat} ${styles.InProgress}`}>Assigned</span> : <span className={`${styles.Stat} ${styles.Open}`}>Open</span>))))}</p>}
                </div>
              </li>
            })}
          </ul>
        </div>
        {historyList.length === 0 && <div className={`${styles.NoDataMainWithBU}`}>
          <div>
            <div className={`${styles.NoDataIMGWithBU}`}><img src="/static/img/no-history.png" alt="" /></div>
            <p className={`${styles.NoDataTextWithBU}`}>History List is Empty</p>
            <p className={`${styles.NoDataTextSubWithBU}`}>No record has been submitted yet.</p>
            {/* <button className={`${styles.AddLeaseBUWithBU}`}><Plus /> Add New</button> */}
          </div>
        </div>}
      </div>}

    </div>
  </>)
}

export default HistoryMobile;
